// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202608260134/js/" + chunkId + "." + {"44":"738e1510","225":"d4c2089d","481":"51ad7dbf","486":"3a949e22","770":"6823ae06"}[chunkId] + ".0.6156948982565598.chunk.js";
};